module.exports = __webpack_public_path__ + "static/media/first.a0099b9b.png";